"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROSE = void 0;
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ What rich text LOOKS LIKE in this product. One string, every surface.     │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * Tailwind's preflight resets every element this styles — a `<strong>` is not bold, a `<ul>` has no
 * markers, an `<h2>` is body size — so a surface that renders markup it did not author has to say
 * what that markup looks like or render an undifferentiated column of text. This is that saying.
 *
 * ⚠️⚠️ **IT LIVES HERE BECAUSE TWO SURFACES NOW PRODUCE MARKUP, AND THEY MUST NOT LOOK DIFFERENT.**
 * It was `COMMENT_PROSE` inside `comment-composer.tsx`, which was the right place while a comment
 * was the only rich text in the product. The Agent's replies are the second (C48), and importing it
 * from there would have pulled **TipTap into the chat's chunk** for the sake of a class string —
 * ProseMirror is not tree-shaken out of a module you import a constant from.
 *
 * ⚠️ **The pairing with `COMMENT_TAGS` is the thing to keep**, and it is a pairing rather than a
 * derivation: `comment-markup.ts` decides what a comment may *contain* — both server and editor read
 * it — and this decides what those tags look like. A tag added there with no rule here renders as
 * body text, which is the same silent failure R-16 names, one layer along.
 *
 * ⚠️ **`table` is styled and no comment can produce one.** The Agent can (R-33), and the rules sit
 * here rather than in the agent screen for the reason above — one place where markup gets its look.
 * ⚠️ Deliberately a HAIRLINE GRID and not the product's `DataList`: a table of the model's own rows
 * must not wear the clothes of a table a service returned. R-33 argues that at length.
 *
 * ⚠️ **`[&_p]:min-h-[1em]`** keeps an empty paragraph — the blank line somebody typed between two
 * others — occupying a line instead of collapsing to nothing.
 */
exports.PROSE = [
    '[&_a]:underline',
    '[&_blockquote]:border-l-2 [&_blockquote]:pl-3',
    '[&_code]:bg-muted [&_code]:rounded [&_code]:px-1',
    /* ⚠️ A code span inside a code BLOCK is not a second pill: `pre` already carries the fill and the
       padding, and without this every fenced block renders as a padded box inside a padded box. */
    '[&_pre_code]:bg-transparent [&_pre_code]:px-0',
    '[&_del]:line-through [&_s]:line-through',
    '[&_h2]:text-[15px] [&_h2]:font-semibold',
    '[&_h3]:text-[13.5px] [&_h3]:font-semibold',
    '[&_ol]:list-decimal [&_ol]:pl-5',
    '[&_p]:min-h-[1em]',
    '[&_pre]:bg-muted [&_pre]:rounded [&_pre]:p-2',
    '[&_ul]:list-disc [&_ul]:pl-5',
    /* ⚠️ `tabular-nums` on the table and not on the prose: a column of hours only lines up if the
       digits are the same width, and running text is worse in tabular figures. */
    '[&_table]:w-full [&_table]:border-collapse [&_table]:text-[12.5px] [&_table]:tabular-nums',
    '[&_th]:bg-muted [&_th]:border [&_th]:px-2 [&_th]:py-1 [&_th]:text-left [&_th]:font-medium',
    '[&_td]:border [&_td]:px-2 [&_td]:py-1 [&_td]:align-top',
].join(' ');
//# sourceMappingURL=prose.js.map